'use client'

import { PickersDay as MuiPickersDay, PickersDayProps as MuiPickersDayProps } from '@mui/x-date-pickers/PickersDay'
import {
    StaticDatePicker as MuiStaticDatePicker,
    StaticDatePickerProps as MuiStaticDatePickerProps,
} from '@mui/x-date-pickers/StaticDatePicker'
import { Dayjs } from 'dayjs'
import { ReactElement } from 'react'
import { tss } from 'tss-react/mui'

export type StaticDatePickerProps = Pick<
    MuiStaticDatePickerProps<Dayjs>,
    'value' | 'onChange' | 'minDate' | 'maxDate' | 'sx' | 'className'
>

const useStyles = tss.create(({ theme }) => ({
    isSameDay: {
        borderTopLeftRadius: '50%',
        borderBottomLeftRadius: '50%',
    },
    isSameDayOrAfter: {
        backgroundColor: theme.palette.action.selected,
    },
}))

function StaticDatePicker(props: StaticDatePickerProps): ReactElement {
    const { classes, cx } = useStyles()
    const { value } = props
    const RenderDay = (pickersDayProps: MuiPickersDayProps<Dayjs>) => {
        const { day } = pickersDayProps

        if (!value) {
            return <MuiPickersDay {...pickersDayProps} />
        }

        const className = cx(
            day.isSame(value, 'day') && classes.isSameDay,
            (day.isSame(value, 'day') || day.isAfter(value, 'day')) && classes.isSameDayOrAfter,
            pickersDayProps.className
        )

        return <MuiPickersDay {...pickersDayProps} key={day.toISOString()} className={className} />
    }

    return <MuiStaticDatePicker {...props} displayStaticWrapperAs="desktop" slots={{ day: RenderDay }} />
}

export default StaticDatePicker
